import * as React from 'react';

import type { User } from '~/shared/auth/useUser';
import ProfileDropdownV2 from '~/shared/components/ProfileDropdown';

import { useUserDropdown } from './hooks';

type HeaderProps = { user: User };

export function UserDropdown({ user }: HeaderProps) {
  const { items, profileInfo } = useUserDropdown({ user });

  return <ProfileDropdownV2 items={items} profileInfo={profileInfo} />;
}
